import { ActionButton } from '@taxbit-private/cosmic'
import styled from 'styled-components'

export const RefreshButton = styled(ActionButton).withConfig<{
  isMenuOpen: boolean
}>({
  shouldForwardProp: (propName) => propName !== 'isMenuOpen',
})``

export const RefreshButtonWithOrangeStatusBubble = styled(ActionButton).withConfig<{
  isMenuOpen: boolean
}>({
  shouldForwardProp: (propName) => propName !== 'isMenuOpen',
})(
  ({ theme }) => `
  svg .status-bubble-path {
    fill: ${theme.color.warning};
  }
`
)

export const RefreshButtonWithBlueStatusBubble = styled(ActionButton).withConfig<{
  isMenuOpen: boolean
}>({
  shouldForwardProp: (propName) => propName !== 'isMenuOpen',
})(
  ({ theme }) => `
  svg .status-bubble-path {
    fill: ${theme.color.primary};
  }
`
)

export const RefreshButtonWithRedStatusBubble = styled(ActionButton).withConfig<{
  isMenuOpen: boolean
}>({
  shouldForwardProp: (propName) => propName !== 'isMenuOpen',
})(
  ({ theme }) => `
  svg .status-bubble-path {
    fill: ${theme.color.danger};
  }
`
)
